import {
  defaulManyDepositsForm,
  defaultBlurCompanyForm,
  defaultBlurDepositForm,
  defaultBlurInvoiceForm,
  defaultBlurLogisticForm,
  defaultBlurLogisticOriginForm,
  defaultBlurManyDeposits,
  defaultBlurTaxForm,
  defaultCompanyForm,
  defaultDepositForm,
  defaultInvoiceForm,
  defaultLogisticForm,
  defaultLogisticOriginForm,
  defaultTaxForm,
} from './utils';

export const initialInvoiceState = (): InvoiceState => ({
  forms: {
    invoices: {
      create: defaultInvoiceForm(),
      update: {
        id: 0,
        ...defaultInvoiceForm(),
      },
    },
    taxes: {
      create: defaultTaxForm(),
      update: {
        id: 0,
        ...defaultTaxForm(),
      },
    },
    companies: {
      create: defaultCompanyForm(),
      update: {
        id: 0,
        ...defaultCompanyForm(),
      },
    },
    deposits: {
      create: defaultDepositForm(),
      update: {
        id: 0,
        ...defaultDepositForm(),
      },
      createMany: [defaultDepositForm()],
      updateMany: defaulManyDepositsForm(),
    },
    logistics: {
      create: defaultLogisticForm(),
      update: {
        id: 0,
        ...defaultLogisticForm()
      }
    },
    logisticOrigins: {
      create: defaultLogisticOriginForm(),
      update: {
        id: 0,
        ...defaultLogisticOriginForm()
      }
    }
  },
  blur: {
    companies: {
      create: defaultBlurCompanyForm(),
      update: defaultBlurCompanyForm(),
    },
    taxes: {
      create: defaultBlurTaxForm(),
      update: defaultBlurTaxForm(),
    },
    invoices: {
      create: defaultBlurInvoiceForm(),
      update: defaultBlurInvoiceForm(),
    },
    deposits: {
      create: defaultBlurDepositForm(),
      createMany: [defaultBlurDepositForm()],
      update: defaultBlurDepositForm(),
      updateMany: defaultBlurManyDeposits(),
    },
    logistics: {
      create: defaultBlurLogisticForm(),
      update: defaultBlurLogisticForm(),
    },
    logisticOrigins: {
      create: defaultBlurLogisticOriginForm(),
      update: defaultBlurLogisticOriginForm(),
    },
  },
  filters: {
    invoices: {
      filter: {
        page: 1,
        limit: 50,
        filter: [],
        orderBy: [],
      },
      data: {
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 50,
        },
        data: [],
        report: {
          totalInvoiceValue: 0,
          totalRealValue: 0,
          totalTotalCost: 0,
          totalUnitSale: 0,
          totalTotalProfit: 0,
          totalTaxes: [],
        },
      },
    },
    taxes: {
      filter: {
        page: 1,
        limit: 50,
        filter: [],
        orderBy: [],
      },
      data: {
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 50,
        },
        data: [],
      },
    },
    companies: {
      filter: {
        page: 1,
        limit: 50,
        filter: [],
        orderBy: [],
      },
      data: {
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 50,
        },
        data: [],
      },
    },
    deposits: {
      filter: {
        page: 1,
        limit: 50,
        filter: [],
        orderBy: [],
      },
      data: {
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 50,
        },
        data: [],
        report: {
          total: 0,
        },
      },
    },
    logistics: {
      filter: {
        page: 1,
        limit: 50,
        filter: [],
        orderBy: [],
      },
      data: {
        report: {
          quantityVolume: 0,
        },
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 50,
        },
        data: [],
      },
    },
    logisticOrigins: {
      filter: {
        page: 1,
        limit: 50,
        filter: [],
        orderBy: [],
      },
      data: {
        report: {
          quantityVolume: 0,
        },
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 50,
        },
        data: [],
      },
    },
    dailyDeposits: {
      filter: {
        page: 1,
        limit: 50,
        filter: [],
        orderBy: [],
      },
      data: {
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 50,
        },
        data: [],
        report: {
          total: 0,
          quantity: 0,
        },
      },
    },
    selectCompanies: {
      filter: {
        page: 1,
        limit: 15,
        filter: [],
        orderBy: [],
      },
      data: {
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 15,
        },
        data: [],
      },
    },
    selectTaxes: {
      filter: {
        page: 1,
        limit: 15,
        filter: [],
        orderBy: [],
      },
      data: {
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 15,
        },
        data: [],
      },
    },
    invoiceProducts: [],
  },
  autocompletes: {
    invoices: {
      product: {
        filter: {
          column: 'product',
          value: '',
          limit: 15,
        },
        data: [],
      },
      company: {
        filter: {
          column: 'company',
          value: '',
          limit: 15,
        },
        data: [],
      },
      group: {
        filter: {
          column: 'group',
          value: '',
          limit: 15,
        },
        data: [],
      },
      crt: {
        filter: {
          column: 'crt',
          value: '',
          limit: 15,
        },
        data: [],
      },
      invoiceNumber: {
        filter: {
          column: 'invoiceNumber',
          value: '',
          limit: 15,
        },
        data: [],
      },
    },
    taxes: {
      name: {
        filter: {
          column: 'name',
          value: '',
          limit: 15,
        },
        data: [],
      },
      description: {
        filter: {
          column: 'description',
          value: '',
          limit: 15,
        },
        data: [],
      },
    },
    logistics: {
      company: {
        filter: {
          column: 'company',
          value: '',
          limit: 15,
        },
        data: [],
      },
      nrcInvoiceNumber: {
        filter: {
          column: 'nrcInvoiceNumber',
          value: '',
          limit: 15,
        },
        data: [],
      },
      clientInvoiceNumber: {
        filter: {
          column: 'clientInvoiceNumber',
          value: '',
          limit: 15,
        },
        data: [],
      },
      crt: {
        filter: {
          column: 'crt',
          value: '',
          limit: 15,
        },
        data: [],
      },
      clientName: {
        filter: {
          column: 'clientName',
          value: '',
          limit: 15,
        },
        data: [],
      },
    },
    logisticOrigins: {
      company: {
        filter: {
          column: 'company',
          value: '',
          limit: 15,
        },
        data: [],
      },
      originInvoiceNumber: {
        filter: {
          column: 'originInvoiceNumber',
          value: '',
          limit: 15,
        },
        data: [],
      },
    },
    companies: {
      name: {
        filter: {
          column: 'name',
          value: '',
          limit: 15,
        },
        data: [],
      },
    },
    deposits: {
      company: {
        filter: {
          column: 'company',
          value: '',
          limit: 15,
        },
        data: [],
      },
      group: {
        filter: {
          column: 'group',
          value: '',
          limit: 15,
        },
        data: [],
      },
    },
  },
  selecteds: {
    companies: [],
    invoices: [],
    taxes: [],
    deposits: [],
    logistics: [],
    logisticOrigins: [],
  },
  loadings: {
    deleteCompanies: [],
    deleteInvoices: [],
    deleteTaxes: [],
    deleteDeposits: [],
    deleteLogistics: [],
    deleteLogisticOrigins: [],
  },
  selected: {
    invoice: -1,
    tax: -1,
    company: -1,
    deposit: -1,
    logistic: -1,
    logisticOrigin: -1,
  },
  dashboard: {
    invoice: {
      data: [],
    },
    deposit: {
      data: [],
    },
  },
  groups: {
    all: [],
    invoice: [],
    deposit: [],
    logistic: [],
  },
  selectedGroupId: null,
});
